<template>
  <footer class="footer bg-simply-blank pt-14 pb-14">
    <app-container>
      <div class="grid grid-cols-12 gap-7">
        <div class="col-span-12 lg:col-span-7 col-start-1">
          <div class="flex items-center gap-12">
            <router-link to="/">
              <LogoIcon :inverted="inverted" />
            </router-link>

            <SocialMedia />
          </div>

          <p class="text-white pt-5 max-w-xl hidden lg:block">
            NZ owned and operated. Simple broadband for Kiwis. Cut unnecessary
            costs and pay for the speed you actually need.<br />
            Part of Global Compare Group Limited, a Kiwi owned and operated
            company with multiple online brands across comparison, broadband and
            digital services.
          </p>

          <router-link
            to="/register"
            class="btn font-bold text-base text-white border border-white py-1.5 px-6 inline-block mt-7 rounded-full hover:bg-green hover:border-green"
          >
            Check our simple plans
          </router-link>
        </div>
        <div
          class="col-span-12 lg:row-span-2 lg:col-span-5 lg:col-start-9 grid gap-7"
        >
          <slot />
        </div>

        <div
          class="col-span-12 font-bold text-white pt-1 flex self-end justify-between items-center"
        >
          &copy; {{ year }} {{ company }}. All rights reserved.
          <img
            src="/images/NZ_Service_Logo_White.png"
            alt="NZ Service Logo"
            class="w-[75px]"
          />
        </div>
      </div>

      <InlineScript
        src="https://cdn.trustindex.io/loader-cert.js?8a00c4f58b06031793562bcf0de"
      />
    </app-container>
  </footer>
</template>

<script lang="ts" setup>
import LogoIcon from "@/components/icons/LogoIcon.vue";
import AppContainer from "@/layout/AppContainer.vue";
import SocialMedia from "@/components/SocialMedia.vue";
import InlineScript from "@/components/InlineScript.vue";

const year = new Date().getFullYear();

defineOptions({ inheritAttrs: false });

type Props = {
  company: string;
  inverted?: boolean;
};

withDefaults(defineProps<Props>(), {
  inverted: false,
});
</script>
